import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogIn, Shield, AlertTriangle } from "lucide-react";

function formatErr(d) {
  if (!d) return "Login failed.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return d.msg || JSON.stringify(d);
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav(loc.state?.from || "/admin", { replace: true });
    } catch (ex) { setErr(formatErr(ex.response?.data?.detail) || "Login failed."); }
    finally { setLoading(false); }
  }

  return (
    <div className="min-h-[80vh] flex items-center" data-testid="login-page" style={{ background: "var(--ivory)" }}>
      <div className="max-w-md mx-auto w-full px-6">
        <div className="thin-border p-8 md:p-10" style={{ background: "var(--ivory)" }}>
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 flex items-center justify-center thin-border" style={{ background: "var(--brass)" }}>
              <Shield size={16} style={{ color: "var(--text)" }} />
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.28em]" style={{ color: "var(--muted)" }}>Operator Access</div>
              <h1 className="font-display text-3xl mt-1" style={{ letterSpacing: "-0.02em" }}>Sign in</h1>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="overline block mb-2">Email</label>
              <input data-testid="login-email" type="email" className="field-boxed" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
            </div>
            <div>
              <label className="overline block mb-2">Password</label>
              <input data-testid="login-password" type="password" className="field-boxed" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
            </div>
            {err && (
              <div className="flex items-start gap-2 px-3 py-2 font-body text-sm" style={{ background: "rgba(217,93,57,0.1)", border: "1px solid var(--terracotta)", color: "var(--terracotta)" }}>
                <AlertTriangle size={14} className="mt-0.5 shrink-0" />
                <span>{err}</span>
              </div>
            )}
            <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center">
              {loading ? "Authenticating…" : "Sign In"} <LogIn size={14} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
